import Track from "util/Track";

export default function handleOnPageNavigationBlocks() {
    let $pageSlider = $(".js-page-nav-slider");
    if ($pageSlider.length > 0) {
        $pageSlider.each(function () {
            handleOnPageNavigationBlock($(this));
        });
    }
}

function handleOnPageNavigationBlock($elem) {
    let track = new Track($elem, {
        classes: {
            block: "slider",
        },
    });

    updateTrackState(track);

    $elem.on('click', '.js-page-navigation-link', function () {
        scrollTo($(this).attr('href'));
        return false;
    });

    let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if(entry.isIntersecting) {
                $elem.find('.js-page-navigation-link').removeClass('slider__link--active');
                const activeLink = $elem.find('.js-page-navigation-link[href="#' + entry.target.id + '"]');
                activeLink.addClass('slider__link--active');
            }
        });
    }, {
        threshold: 1,
    });

    $elem.find('.js-page-navigation-link').each(function () {
        let id = $(this).attr('href');
        observer.observe($(id)[0]);
    });

    $(window).on('resize', () => {
        updateTrackState(track);
    });
}


export function scrollTo(id) {
    let scrollTop = $(id).offset().top;
    $('html, body').animate({scrollTop: scrollTop - 70}, 300);
}

function updateTrackState(track) {
    if ($(track.$wrap).outerWidth() > $(track.$element).find('.js-outer-wrap').outerWidth()) {
        track.enable();
        track.$element.removeClass('slider--disabled');
    } else {
        track.disable();
        track.$element.addClass('slider--disabled');
    }
}

